@if (config.isInternal) {
  <div class="smc-button-box">
    <div class="smc-content">
      @if (templateContent.heading) {
        <p class="c11n-text-md-bold padding-top-1 padding-bottom-2"
        [innerHTML]="templateContent.heading"></p>
      }
      <div class="smc-button-container">
        @for (section of templateContent.sections; track section; let i = $index) {
          <div class="smc-button-section">
            @if (!smcMessagesSent[section.smcTemplateKey]) {
              <p class="c11n-text-md padding-bottom-1" [innerHTML]="section.smcMsg"></p>
              <c11n-button variant="secondary" (clickEvent)="sendSecureMessage(section.smcTemplateKey)" fullWidth="true"
                [labelText]="section.smcButton">
              </c11n-button>
            }
            @if (smcMessagesSent[section.smcTemplateKey]) {
              <p class="c11n-text-md" [innerHTML]="content.thankYou.description"></p>
              <a class="c11n-text-md" [innerHTML]="content.thankYou.smcLinkLabel"
              [href]="config.origin + content.thankYou.smcLink"></a>
            }
          </div>
          @if (i !== templateContent.sections.length - 1) {
            <div class="vertical-line"></div>
          }
        }
      </div>
    </div>
  </div>
}
